import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  IconButton,
  Alert,
  CircularProgress
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CommonButton from "../../../components/CommonButton/CommonButton";
import { DialogProps } from "./types";

const DeactivateVideoDialog: React.FC<DialogProps> = ({
  open,
  onClose,
  onConfirm,
  loading,
  error
}) => {
  return (
    <Dialog
      open={open}
      onClose={() => !loading && onClose()}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography sx={{ fontWeight: 600, fontSize: "18px" }}>
            Confirm Deactivation
          </Typography>
          <IconButton onClick={() => !loading && onClose()} disabled={loading}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        {error && (
          <div style={{ marginTop: "5px", marginBottom: "16px" }}>
            <Alert severity="error">{error}</Alert>
          </div>
        )}
        <Typography>Are you sure you want to deactivate this video?</Typography>
      </DialogContent>
      <DialogActions>
        <CommonButton onClick={() => !loading && onClose()} disabled={loading}>
          Cancel
        </CommonButton>
        <CommonButton onClick={onConfirm} color="error" disabled={loading}>
          {loading ? <CircularProgress size={20} /> : "Deactivate"}
        </CommonButton>
      </DialogActions>
    </Dialog>
  );
};

export default DeactivateVideoDialog;
